import { lazyGetOfflineTimeZoneOffsets, lazyGetOfflineTimeZones } from "owa-data-worker-client";
import { timeZonesGetter } from "./timeZonesGetter";
import type TimeZoneOffsetsType from "owa-service/lib/contract/TimeZoneOffsetsType";
import type TimeZoneEntry from "owa-service/lib/contract/TimeZoneEntry";

function getTimeZones(): Promise<TimeZoneEntry[] | undefined> {
    return timeZonesGetter(lazyGetOfflineTimeZones.importAndExecute);
}

function getTimeZoneOffsets(): Promise<TimeZoneOffsetsType[] | undefined> {
    return timeZonesGetter(lazyGetOfflineTimeZoneOffsets.importAndExecute);
}

export const getTimeZoneOverrides: {
    getTimeZones: typeof getTimeZones;
    getTimeZoneOffsets: typeof getTimeZoneOffsets;
} = {
    getTimeZones,
    getTimeZoneOffsets,
};
